export default __webpack_public_path__ + "static/media/checkMark.5b2219d1.svg";